import type { ValueFormatterParams } from 'ag-grid-community';

import { createBigNumber, formatNonZeroNumberToLocaleString } from '../number';

export const valueFormatterZero = ({ value }: Pick<ValueFormatterParams, 'value'>) =>
  typeof value === 'number'
    ? formatNonZeroNumberToLocaleString(value, { defaultValue: '-' })
    : value;

export const valueFormatterZeroWithNull = ({ value }: Pick<ValueFormatterParams, 'value'>) => {
  if (value === null || value === undefined) {
    return '-';
  }

  return typeof value === 'number'
    ? formatNonZeroNumberToLocaleString(value, { defaultValue: '-' })
    : value;
};

export const valueFormatterPercentage = ({ value }: Pick<ValueFormatterParams, 'value'>) => {
  if (value === null || value === undefined || value === 0) {
    return '-';
  }

  if (value === 'MINUS_INFINITY') {
    return '-∞';
  }

  if (value === 'INFINITY') {
    return '+∞';
  }

  return typeof value === 'number'
    ? `${createBigNumber(value).mul(100).toFixed(0)} %`
    : `${value} %`;
};

export const valueFormatterNullableNumber = ({ value }: Pick<ValueFormatterParams, 'value'>) => {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  if (value === 0) {
    return '-';
  }

  return typeof value === 'number' ? formatNonZeroNumberToLocaleString(value) : value;
};
